<div class="flex">
    <!-- image -->
    @if (product) {
    <a class="m-r ratio-1-1"
       style="width: 126px;"
       [routerLink]="product.data.url">
        <img class="rf"
             [image]="product.data.image">
    </a>
    }
    <!-- details -->
    <div class="flex-grow">

        <div class="p-l-3 p-b p-l-1-s p-l-1-m float-right">
            <price class="p1 col-1 block price"
                   [value]="orderItem?.data?.row_total_incl_tax"></price>
        </div>

        <href class="p1 col-1 block"
              [link]="product?.data.url">{{ product?.data.name || orderItem?.data.name}}</href>

        <!-- configurable options -->
        <p class="c1 col-4 m-t-5">
            @for (option of orderItem?.configurableOptions; track option; let index = $index) {
            @if (index) {
        <div class="vbar m-l-1 m-r-1"></div>
        }
        {{option.value | optionLabel : option.code}}
        }
        </p>

        <!-- qty -->
        <div class="m-t p2">
            {{'Qty: %' | translate : orderItem?.data?.qty_ordered}}
        </div>
    </div>
</div>
